import {
  ChildrenBlockSpacingContainer,
  ContentfulBlocks,
} from '@dreamstack/accentro-contentful'
import { useLocale } from '@dreamstack/i18n'
import { trpc } from '@dreamstack/trpc/client'
import isEmpty from 'lodash/isEmpty'
import type { FunctionComponent } from 'react'
import 'twin.macro'

export const ProjectPageBlocks: FunctionComponent<
  React.PropsWithChildren<{
    projectId: number
    blockField: 'blocksBelowImages'
  }>
> = ({ projectId, blockField }) => {
  const locale = useLocale()
  const { data } = trpc.cms.getProjectPage.useQuery(
    { locale, projectId },
      {
          trpc: { ssr: true },
          staleTime: Infinity,
          // enabled: !!projectId,
      }
  )

  const blocks = data?.[blockField]

  if (!blocks || isEmpty(blocks)) return null

  return (
    <div tw="col-span-full">
      <div tw="mb-px-64 col-span-full ml:(mb-px-96)">
        <ChildrenBlockSpacingContainer>
          <ContentfulBlocks blocks={blocks} />
        </ChildrenBlockSpacingContainer>
      </div>
    </div>
  )
}
